module.exports = __webpack_public_path__ + "src/assets/textures/env/hay/well_hay_512_bake.png";